__turbopack_context__.v({
  "button": "FormButton-module-scss-module__TiPcsW__button",
  "loading-spinner": "FormButton-module-scss-module__TiPcsW__loading-spinner",
  "rotate": "FormButton-module-scss-module__TiPcsW__rotate",
});
